<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import { rules } from '@/utils/validators'

import { Plugins } from '@capacitor/core'
const { Browser } = Plugins

import { IS_EMAIL_AVAILABLE_QUERY } from '@/graph/gql/user.gql'

export default {
  name: 'OnboardingProfileEmail',
  mixins: [validationMixin],
  props: {
    user: { type: Object, required: true },
    submitting: { type: Boolean, default: () => false }
  },
  apollo: {
    isEmailAvailable: {
      query: IS_EMAIL_AVAILABLE_QUERY,
      variables() {
        return { email: this.form.email }
      },
      skip() {
        return this.$v.$invalid
      },
      result: x => console.log(x.data)
    }
  },
  data: () => ({
    rules,
    form: {
      email: '',
      agreements: {
        clientTos: true,
        privacyPolicy: true
      }
    }
  }),
  created() {
    // Event tracking
    const { once } = this.lodash
    const { logEvent } = this.$amplitude

    const emailAdded = once(() => {
      const props = { email: this.form.email }
      logEvent('Buyer Onboarding: Email Added', props)
    })
    this.emailAdded = () => {
      if (this.form.email) emailAdded()
    }

    this.tosAgreed = once(() => {
      logEvent('Buyer Onboarding: TOS Agreed')
    })

    // Prefill form
    const { email } = this.user || {}
    this.form = { email }
  },
  methods: {
    submit() {
      if (this.submitting || this.$v.$invalid) return
      if (this.$apollo.loading || !this.isEmailAvailable) return

      this.tosAgreed()

      const data = this.form
      this.$emit('submit', data)
    },

    openTos() {
      Browser.open({ url: 'https://www.pona.app/tos/' })
    },

    openPrivacy() {
      Browser.open({ url: 'https://www.pona.app/privacy/' })
    }
  },
  validations: {
    form: {
      email: {
        required,
        email
      }
    }
  }
}
</script>

<template>
  <div class="view-grid">
    <transition name="slide-up">
      <div class="mt-3">
        <!-- Onboarding Profile // Email -->
        <v-form @submit.prevent="submit()">
          <!-- Title -->
          <p class="subtitle-1 font-weight-medium mb-1">
            What's your email?
          </p>
          <!-- Subtitle -->
          <p class="body-2">
            We'll use it to send you important information about your account
            and orders.
          </p>

          <v-text-field
            v-model.trim="form.email"
            :rules="[rules.required, rules.email]"
            :error-messages="
              $v.$invalid || $apollo.loading || isEmailAvailable
                ? []
                : ['This Email is already in use']
            "
            validate-on-blur
            class="secondary--text"
            label="Email"
            @blur="emailAdded"
          />

          <v-btn
            :loading="submitting || $apollo.loading"
            :disabled="$v.$invalid || $apollo.loading || !isEmailAvailable"
            type="submit"
            rounded
            depressed
            color="primary"
            class="mt-2 px-10"
          >
            Next
          </v-btn>

          <!-- TODO: add links -->
          <p class="mt-5 body-2 blue-grey--text">
            By tapping next you agree to our <br />
            <a href="https://www.pona.app/tos/" @click="openTos"
              >Terms of Service</a
            >
            and
            <a href="https://www.pona.app/privacy/" @click="openPrivacy"
              >Privacy Policy</a
            >.
          </p>
        </v-form>
      </div>
    </transition>
  </div>
</template>

<style scoped></style>
